import * as React from "react";

function SvgDashboard({ ...props }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.56016 5.94535V16.7204H10.1066V5.94535H4.56016ZM3.76472 4H10.902C11.5084 4 12.0001 4.50508 12.0001 5.12814V17.5376C12.0001 18.1606 11.5084 18.6657 10.902 18.6657H3.76472C3.15829 18.6657 2.66669 18.1606 2.66669 17.5376V5.12814C2.66669 4.50508 3.15829 4 3.76472 4Z"
        fill="currentColor"
      />
      <path
        d="M15.5406 5.94535V8.82344H19.44V5.94535H15.5406ZM14.7452 4H20.2354C20.8418 4 21.3335 4.50508 21.3335 5.12814V9.64066C21.3335 10.2637 20.8418 10.7688 20.2354 10.7688H14.7452C14.1388 10.7688 13.6472 10.2637 13.6472 9.64066V5.12814C13.6472 4.50508 14.1388 4 14.7452 4Z"
        fill="currentColor"
      />
      <path
        d="M15.5406 13.8428V16.7209H19.44V13.8428H15.5406ZM14.7452 11.8975H20.2354C20.8418 11.8975 21.3335 12.4025 21.3335 13.0256V17.5381C21.3335 18.1612 20.8418 18.6663 20.2354 18.6663H14.7452C14.1388 18.6663 13.6472 18.1612 13.6472 17.5381V13.0256C13.6472 12.4025 14.1388 11.8975 14.7452 11.8975Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgDashboard;
